import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GlobalService } from 'src/app/services/global.service';
import { HttpClient } from '@angular/common/http';

import { MapServiceService } from '../../../services/Map-service/map-service.service';
import { SideNavService } from '../../../services/sidenav/side-nav.service';
import { LoaderComponent } from 'src/app/modules/shared/components/loader/loader.component';
import Polygon, { fromExtent } from 'ol/geom/Polygon';
import { Feature } from 'ol';

@Component({
  selector: 'app-query',
  templateUrl: './query.component.html',
  styleUrls: ['./query.component.css'],
})
export class QueryComponent implements OnInit {
  query: any;
  layers: any;
  selectedLayer: any;
  selectedFeatures: any;
  queryForm: any;
  array: any;
  eventName: any;
  formBuilder: any;
  clickArray: any = [];
  toolTip: any;
  operators: any = [];
  values: any = [];
  fieldKeys: any = [];
  mapId: any;
  defaultValue: any;
  defaultName: any;
  selectedValue: any;
  save: any;
  html: any;
  keyMes = 'mapId';
  decrypted: any;
  mapAccessLevel: any;
  layerName: any
  filedName: any
  constrainBounds: any;
  query_dropdown = false
  query_dropdown_list: any
  @ViewChild(LoaderComponent, { static: false }) loader!: LoaderComponent;
  @ViewChild('formDirective') private formDirective: any;
  constructor(
    public sideNavService: SideNavService,
    public mapServices: MapServiceService,
    private fb: FormBuilder,
    private global: GlobalService,
    private http: HttpClient
  ) {
    //
  }
  queryToolTip = 'Clear entry';
  queryToolTipGo = '<span>Run query<br>now</span>';
  myOptions4 = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class4',
  };

  ngOnInit(): void {
    this.mapId = this.mapServices.mapData.map_data.map_data.id;
    if (!this.mapServices.accessMapApi.map_data.map_data.tool_desc.query) {
      this.html = '';
    } else {
      this.html =
        this.mapServices.accessMapApi.map_data.map_data.tool_desc.query;
    }
    this.toolTip = this.mapServices.mapData.map_data.map_data.tools_tips;
    this.query = this.mapServices.mapData.map_data.map_data.tool_desc.query;
    this.mapAccessLevel = this.mapServices.mapData.map_access_level;
    this.layers = this.mapServices.mapData.map_data.map_data.layers;

    this.layers.sort((a: any, b: any) => {
      return a.select_order - b.select_order;
    });
    let save: any;
    for (let i = 0; i < this.layers.length; i++) {
      if (this.layers[i].selectable) {
        this.defaultValue = this.layers[i];
        save = i;
        break;
      }
    }

    if (
      this.layers[save].fields.length != 0 &&
      this.layers[save].fields[0].searchable
    ) {
      this.defaultName = this.layers[save].fields[0].id;
    } else {
      this.defaultName = 0;
    }

    this.selectedValue = 'almost';
    this.queryForm = this.fb.group({
      feature: new FormControl(this.defaultValue.id),
      data: this.fb.array([this.createFirstTime(this.defaultName)]),
    });
  }

  createFirstTime(value: any): FormGroup {
    {
      return this.fb.group({
        attribute: value,
        relation: '',
        condition: '',
      });
    }
  }

  createFormData(): FormGroup {
    {
      return this.fb.group({
        attribute: '',
        relation: '',
        condition: '',
      });
    }
  }

  addAnother(i: number) {
    this.array = this.queryForm.get('data') as FormArray;
    this.array.push(this.createFormData());
    this.clickArray[i] = true;
  }

  removeSkill(index: number) {
    this.array.removeAt(index + 1);
    this.clickArray[index] = undefined;
  }

  get data(): FormArray {
    return this.queryForm.get('data') as FormArray;
  }

  getQuerryDropdownValue(list: any): void {
    for (let l = 0; l < this.layers.length; l++) {
      for (let j = 0; j < this.layers[l].fields.length; j++) {
        if (
          this.layers[l].fields[j].id == list.target.value
        ) {
          this.query_dropdown = this.layers[l].fields[j].query_dropdown
          this.query_dropdown_list = this.layers[l].fields[j].query_dropdown_list.list_values
        }
      }
    }
  }

  submit() {
    this.operators = [];
    this.values = [];
    this.fieldKeys = [];
    for (let i = 0; i < this.queryForm.value.data.length; i++) {
      if (this.queryForm.value.data[i].relation) {
        this.operators.push(this.queryForm.value.data[i].relation);
      }
      if (this.queryForm.value.data[i].condition) {
        this.values.push(this.queryForm.value.data[i].condition);
        this.mapServices.apnValues.push(this.queryForm.value.data[i].condition);
      }
      if (this.queryForm.value.data[i].attribute) {
        for (let l = 0; l < this.layers.length; l++) {
          for (let j = 0; j < this.layers[l].fields.length; j++) {
            if (
              this.layers[l].fields[j].id ==
              this.queryForm.value.data[i].attribute &&
              this.layers[l].fields[j].searchable
            ) {
              this.fieldKeys.push(this.queryForm.value.data[i].attribute);
              this.filedName = this.layers[l].fields[j].name
            }
          }
        }
      }
    }

    if (!this.values) {
      this.values = [''];
    }
    if (this.fieldKeys.length) {
      this.activityLoging(
        this.layerName.toString(),
        this.values.toString(),
        this.operators.toString(),
        this.filedName.toString(),
        (this.eventName = 'Query:GO')
      );
      this.loader.toggleSpinner(true);
      //Query. Constrain to map view
      this.constrainBounds = this.mapServices.mapLayer
        .getView()
        .calculateExtent(this.mapServices.mapLayer.getSize());
      const newPolygon = fromExtent(this.constrainBounds);
      const insideFeature = new Feature({
        geometry: new Polygon(newPolygon.getCoordinates()),
      });
      const wkt = insideFeature.getGeometry()?.getCoordinates();
      const wktStr =
        'POLYGON(' +
        wkt
          ?.map((ring: any) => {
            return (
              '(' +
              ring
                .map((p: any) => {
                  return p[0] + ' ' + p[1];
                })
                .join(', ') +
              ')'
            );
          })
          .join(', ') +
        ')';
      //End
      if (this.operators.length == 0 && !this.query_dropdown) {
        this.operators = 'almost';
      }
      if(this.query_dropdown) {
        this.operators = 'exact';
      }
      this.mapServices
        .querySearch(
          this.queryForm.value.feature.toString(),
          this.values.toString(),
          this.operators.toString(),
          this.fieldKeys.toString(),
          this.mapId,
          wktStr
        )
        .subscribe((res: any) => {
          this.fieldKeys = [];
          this.values = [];
          this.operators = [];
          this.sideNavService.setFeatureNameView = true;
          this.selectedFeatures = res.features;
          const fields: any = {};
          if (this.selectedFeatures.length > 1) {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              this.mapServices.multiParcelId.push(this.selectedFeatures[i].id);
              if (fields[this.selectedFeatures[i].layer_id]) {
                fields[this.selectedFeatures[i].layer_id.toString()].push(
                  this.selectedFeatures[i].id.toString()
                );
              } else {
                fields[this.selectedFeatures[i].layer_id] = [];
                fields[this.selectedFeatures[i].layer_id.toString()].push(
                  this.selectedFeatures[i].id.toString()
                );
              }
              this.mapServices.parcel = JSON.stringify(fields);
              this.mapServices.featureLayersId.push(
                this.selectedFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          } else {
            this.mapServices.parcel = '';
            this.mapServices.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              this.mapServices.multiParcelId.push(this.selectedFeatures[i].id);
              // multiParcel
              this.mapServices.multiParcel = false;
              // parcel ID
              this.mapServices.parcels.push(this.selectedFeatures[i].id);
              this.mapServices.parcel = [
                ...new Set(this.mapServices.parcels),
              ].toString();
              // Feature Layer Id
              this.mapServices.featureLayersId.push(
                this.selectedFeatures[i].layer_id
              );
              this.mapServices.featureLayerId = [
                ...new Set(this.mapServices.featureLayersId),
              ].toString();
            }
          }
          this.loader.toggleSpinner(false);
          this.sideNavService.decideComponent(res);
        });
    }
  }

  get dataArray() {
    return this.queryForm.get('data') as FormArray;
  }

  clearForm(): void {
    this.clickArray = [];
    this.queryForm = this.fb.group({
      feature: new FormControl(),
      data: this.fb.array([this.createFormData()]),
    });
    this.activityLoging('', '', '', '', (this.eventName = 'Query:ClearEntry'));
  }

  changeDefaultName(event: any): void {
    this.clickArray = [];
    const getLayer = this.layers.find((name: any) => name.id === +event.target.value);
    this.layerName = getLayer.name
    this.clearFormArray(event.target.value);
  }

  clearFormArray(value: any): void {
    this.defaultName = '';
    for (let i = 0; i < this.layers.length; i++) {
      if (this.layers[i].id == value) {
        this.defaultValue = this.layers[i];
        for (let j = 0; j < this.layers[i].fields.length; j++) {
          if (
            this.layers[i].fields.length != 0 &&
            this.layers[i].fields[j].searchable
          ) {
            this.defaultName = this.layers[i].fields[0].id;
            break;
          }
        }
        break;
      }
    }
    this.queryForm = this.fb.group({
      feature: new FormControl(this.defaultValue.id),
      data: this.fb.array([this.createFirstTime(this.defaultName)]),
    });
  }

  closeLeft() {
    this.mapServices.setClosePanel(true);
    this.mapServices.closePanel = true;
  }

  activityLoging(
    layerName: any,
    attributeField: any,
    relationship: any,
    condition: any,
    eventName: any
  ) {
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapServices.ipAddress = res.ip;
        const body = {
          point: '',
          wkt: '',
          map_id: this.mapId.toString(),
          event: 'Click',
          page: this.mapServices.pageUrl,
          basemap: this.mapServices.shareCurrentMap,
          event_name: eventName,
          ip: this.mapServices.ipAddress,
          time: this.mapServices.getTimeOnPage().toString(),
          event_information: JSON.stringify({
            'query_feature_layer': `${layerName}`,
            'query_attribute_field': `${condition}`,
            'query_relationship': `${relationship}`,
            'query_condition': `${attributeField}`,
          }),
        };
        this.mapServices.activityLogs(body).subscribe(
          () => {
            // console.log('a');
          },
          (error: any) => {
            if (error.status == 403) {
              location.reload();
            }
          }
        );
      });
  }
}
